// extracted by mini-css-extract-plugin
export default {"item":"Item_item__v+D2e","delete":"Item_delete__L+50r","content":"Item_content__-0nqK"};